import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { FaExternalLinkAlt, FaArrowRight, FaLaptopCode } from 'react-icons/fa';
import { projects } from '../data/projects';
import './Projects.css';

const fadeUp = {
  hidden: { opacity: 0, y: 34 },
  visible: { opacity: 1, y: 0 },
};

function LaptopMockup({ image, title }) {
  return (
    <div className="laptop-mockup">
      <div className="laptop-mockup__screen">
        <div className="laptop-mockup__bar">
          <span /><span /><span />
          <small>{title}</small>
        </div>

        <div className="laptop-mockup__display">
          <img src={image} alt={`${title} website screenshot`} loading="lazy" />
        </div>
      </div>

      <div className="laptop-mockup__base">
        <div className="laptop-mockup__notch" />
      </div>
      <div className="laptop-mockup__foot" />
    </div>
  );
}

export default function Projects() {
  const featuredProjects = projects.slice(0, 2);

  return (
    <>
      <Helmet>
        <title>Web Development Portfolio & Projects | Amresh Prajapati</title>
        <meta
          name="description"
          content="Explore website design & development projects by Amresh Prajapati — business websites, React apps, WordPress sites & ecommerce stores built for clients in Mumbai, Virar, Vasai & across India."
        />
        <meta
          name="keywords"
          content="Amresh Prajapati projects, website developer portfolio Mumbai, freelance web developer Mumbai, WordPress projects, React website portfolio, web design projects India"
        />
        <link rel="canonical" href="https://freelanceramreshprajapatimumbai.in/projects" />
      </Helmet>

      <section className="projectsHero">
        <div className="projectsContainer">
          <motion.div
            className="projectsHero__content"
            variants={fadeUp}
            initial="hidden"
            animate="visible"
            transition={{ duration: 0.65 }}
          >
            <span className="projectsTag"><FaLaptopCode /> Portfolio</span>
            <h1>
              My Featured <span>Website Projects</span>
            </h1>
            <p>
              Here are selected projects I can showcase publicly. Many client projects are private,
              but these examples reflect my website design, development and SEO-focused work.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="projectsSection">
        <div className="projectsContainer">
          <motion.div layout className="projects-laptop-grid">
            {featuredProjects.map((project, index) => (
              <motion.article
                className="project-laptop-item"
                key={project.id}
                initial={{ opacity: 0, y: 34, scale: 0.96 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: index * 0.08 }}
              >
                <LaptopMockup image={project.image} title={project.title} />

                <div className="project-laptop-info">
                  <span className="project-cat">{project.category}</span>
                  <h3>{project.title}</h3>
                  {project.subtitle && <h4>{project.subtitle}</h4>}
                  <p>{project.description}</p>

                  <div className="project-tags">
                    {project.tags.map((tag) => (
                      <span className="project-tag" key={tag}>{tag}</span>
                    ))}
                  </div>

                  <a
                    href={project.url || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-view-btn"
                  >
                    View Project <FaExternalLinkAlt />
                  </a>
                </div>
              </motion.article>
            ))}
          </motion.div>
        </div>
      </section>

      <section className="projectsCTA">
        <div className="projectsContainer">
          <motion.div
            className="projectsCTA__box"
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
          







            <span className="projectsTag">Proven Experience</span>

<h2>
  50+ Websites Delivered Successfully — <span>Your Project Next</span>
</h2>

<p>
  I build modern, fast and high-converting websites including business sites,
  landing pages, portfolios and custom web applications tailored for your brand.
</p>

<Link to="/contact" className="projectsBtn">
  Start Your Project <FaArrowRight />
</Link>
          </motion.div>
        </div>
      </section>
    </>
  );
}